// translations/pt-BR.ts
export default {
  // AUTH
  login: 'Entrar',
  signup: 'Cadastrar',
  forgotPassword: 'Esqueci minha senha',
  email: 'E-mail',
  senha: 'Senha',
  password: 'Senha',
  confirmPassword: 'Confirmar senha',
  name: 'Nome',
  createDevAccount: 'Criar conta DEV automática',
  autoDev: 'Conta DEV (para testes rápidos)',
  welcomeBack: 'Bem-vindo de volta',
  noAccount: 'Não tem conta?',
  haveAccount: 'Já tem conta?',
  naoTemConta: 'Ainda não possui uma conta?',
  cadastrar: 'Criar conta',
  entrar: 'Entrar',
  esqueceuSenha: 'Esqueceu sua senha?',
  ouContinuarCom: 'Ou continue com',
  entrarComGoogle: 'Entrar com Google',
  entrarComGithub: 'Entrar com GitHub',
  entrarComoDev: 'Entrar como desenvolvedor',
  credenciaisInvalidas: 'Email ou senha incorretos.',
  recuperarSenha: 'Recuperar senha',
  enviarLinkRecuperacao: 'Enviar link de recuperação',
  voltarLogin: 'Voltar ao login',
  linkRecuperacaoEnviado: 'Link de recuperação enviado! Verifique seu e-mail.',
  emailInvalido: 'Digite um e-mail válido',
  emailEnviado: 'E-mail enviado com sucesso!',
  erroEnviarEmail: 'Não foi possível enviar o e-mail. Tente novamente.',
  verifiqueSeuEmail: 'Verifique seu e-mail',

  // TOPBAR / GERAL
  search: 'Buscar demandas, chats, notas...',
  notifications: 'Notificações',
  profile: 'Perfil',
  newDemand: 'Nova Demanda',
  novaDemanda: 'Nova Demanda',

  // SIDEBAR
  sidebar: {
    dashboard: 'Dashboard',
    inbox: 'Inbox',
    demandas: 'Demandas',
    projetos: 'Projetos',
    kanban: 'Kanban',
    calendario: 'Calendário',
    gantt: 'Gantt',
    timeTracker: 'Tempo',
    aiStudio: 'IA Studio',
    notas: 'Notas',
    objetivos: 'Objetivos',
    relatorios: 'Relatórios',
    equipe: 'Equipe',
    chatGlobal: 'Chat',
    chat: 'Chat',
    templates: 'Templates',
    configuracoes: 'Configurações',
  },

  // MOBILE MENU
  mobileMenu: {
    abrirMenu: 'Abrir menu',
    fecharMenu: 'Fechar menu',
  },

  // NAVEGAÇÃO
  dashboard: 'Dashboard',
  inbox: 'Inbox Unificado',
  projetos: 'Projetos',
  kanban: 'Kanban',
  demandas: 'Lista de Demandas',
  calendario: 'Calendário',
  gantt: 'Gantt',
  timeTracker: 'Rastreador de Tempo',
  aiStudio: 'AI Studio / Co-Pilot',
  notas: 'Bloco de Notas',
  templates: 'Templates',
  objetivos: 'Objetivos & OKRs',
  relatorios: 'Relatórios & Insights',
  equipe: 'Equipe & Permissões',
  chat: 'Chat Global',
  configuracoes: 'Configurações',
  integracoes: 'Integrações',
  planos: 'Planos & Cobrança',
  ajuda: 'Ajuda & Suporte IA',
  logout: 'Sair',

  // CONFIGURAÇÕES
  meusDados: 'Meus Dados',
  tema: 'Tema',
  idioma: 'Idioma',
  notificacoes: 'Notificações',
  salvar: 'Salvar Alterações',
  atualizarFoto: 'Atualizar Foto',
  alterarSenha: 'Alterar Senha',

  light: 'Claro',
  dark: 'Escuro',
  system: 'Sistema',
  gray: 'Cinza',

  ptBR: 'Português (Brasil)',
  en: 'Inglês',

  // DEMANDAS
  novaDemandaBtn: 'Nova Demanda',
  atrasadas: 'Atrasadas',
  emProgresso: 'Em Progresso',
  concluidas: 'Concluídas',
  totalDemandas: 'Total de Demandas',
  sugerirIA: 'Sugestão IA',
  enviar: 'Enviar',
  notasDaDemanda: 'Notas',
  chatDaDemanda: 'Chat',
  detalhes: 'Detalhes',
  atividade: 'Atividade',
  anexos: 'Anexos',
  subtarefas: 'Subtarefas',
  historico: 'Histórico de Versões',
  prioridade: 'Prioridade',
  responsavel: 'Responsável',
  prazo: 'Prazo',
  tags: 'Tags',
  criar: 'Criar',
  cancelar: 'Cancelar',
  editar: 'Editar',
  excluir: 'Excluir',
  sim: 'Sim',
  nao: 'Não',
  carregando: 'Carregando...',
  offline: 'Modo Offline - Dados salvos localmente',
  sincronizando: 'Sincronizando ao conectar...',
  status: 'Status',
  titulo: 'Título',
  descricao: 'Descrição',
  todos: 'Todos',
  total: 'Total',
  progresso: 'Progresso',
  pendente: 'Pendente',
  concluido: 'Concluído',
  atrasado: 'Atrasado',
  arquivado: 'Arquivado',
  arquivar: 'Arquivar',
  aberta: 'Aberta',
  bloqueada: 'Bloqueada',
  emAndamento: 'Em Andamento',
  naoIniciado: 'Não Iniciado',
  erro: 'Erro',
  excluindo: 'Excluindo...',
  salvando: 'Salvando...',
  campoObrigatorio: 'Campo obrigatório',
  dataInvalida: 'Data inválida',
  progressoInvalido: 'Progresso inválido',
  confirmarExclusao: 'Confirmar exclusão',
  temCertezaQueDesejaExcluir: 'Tem certeza que deseja excluir?',

  // DASHBOARD
  demandasRecentes: 'Demandas Recentes',
  proximosPrazos: 'Próximos Prazos',
  progressoDemandas: 'Progresso das Demandas',
  progressoMedio: 'Progresso Médio',
  visaoGeralStatuses: 'Visão Geral por Status',
  ultimasDemandasCriadas: 'Últimas Demandas Criadas',
  nenhumaDemandaRecente: 'Nenhuma demanda recente',
  nenhumPrazoProximo: 'Nenhum prazo próximo',
  concluidasEstaSemana: 'Concluídas esta semana',
  vencemEmBreve: 'Vencem em breve',
  totalDemandasDesc: 'Total de demandas cadastradas',
  atrasadasDesc: 'Demandas com prazo vencido',
  emProgressoDesc: 'Demandas em andamento',
  concluidasDesc: 'Demandas finalizadas',
  bloqueadas: 'Bloqueadas',
  bloqueadasDesc: 'Demandas bloqueadas',
  bemVindoMensagem: 'Bem-vindo ao Havk',
  buscarPorTituloDescricaoOuTag: 'Buscar por título, descrição ou tag...',
  diaRestante: 'dia restante',
  diasRestantes: 'dias restantes',
  evolucaoStatus: 'Evolução por Status',
  evolucaoPorStatus: 'Evolução por Status',
  distribuicaoStatus: 'Distribuição por Status',
  acompanhamentoDeMetasDaEquipeEDashboardInterativo: 'Acompanhamento de metas da equipe e dashboard interativo',

  // PERFIL
  perfilAtualizado: 'Perfil atualizado com sucesso!',
  cliqueParaAlterarFoto: 'Clique na câmera para escolher foto da galeria',
  salvarAlteracoes: 'Salvar Alterações',
  permissoesSeguranca: 'Permissões & Segurança',

  // TIME TRACKER
  timeTrackerTitle: 'Rastreador de Tempo',
  timeTrackerDescription: 'Gerencie e acompanhe o tempo gasto em suas tarefas',
  taskNamePlaceholder: 'Nome da tarefa atual...',
  digiteNomeTarefa: 'Nome da tarefa atual...',
  start: 'Iniciar',
  pause: 'Pausar',
  stop: 'Finalizar',
  reset: 'Resetar',
  activeSession: 'Sessão ativa em andamento',
  sessionHistory: 'Histórico de Sessões',
  clearHistory: 'Limpar histórico',
  statistics: 'Estatísticas',
  totalTrackedTime: 'Tempo total rastreado',
  totalSessions: 'Total de sessões',
  nenhumaSessaoAinda: 'Nenhuma sessão registrada ainda',
  sessaoRegistrada: 'Sessão registrada com sucesso',
  sessaoExcluida: 'Sessão excluída',
  historicoLimpo: 'Histórico limpo',
  confirmarLimparHistorico: 'Tem certeza que deseja limpar o histórico?',
  timerResetado: 'Timer resetado',
  timePerTask: 'Tempo por tarefa',

  // RELATÓRIOS
  analiseDesempenho: 'Análise de desempenho e produtividade',
  ultimos30Dias: 'Últimos 30 dias',
  ultimos90Dias: 'Últimos 90 dias',
  esteAno: 'Este ano',
  todoHistorico: 'Todo o histórico',
  demandasConcluidas: 'Demandas Concluídas',
  taxaConclusao: 'Taxa de Conclusão',
  mediaTempo: 'Tempo Médio de Conclusão',
  dias: 'dias',
  evolucaoConclusoes: 'Evolução de Conclusões',
  ultimosMeses: 'Últimos meses',
  nenhumDadoPeriodo: 'Nenhum dado no período selecionado',
  situacaoAtualDemandas: 'Situação atual das demandas',
  topPerformers: 'Top Performers',
  responsaveisMaisConclusoes: 'Responsáveis com mais conclusões',
  nenhumDadoDisponivel: 'Nenhum dado disponível',
  mesAno: 'Mês/Ano',
  csvExportado: 'CSV exportado com sucesso!',
  gerandoPDF: 'Gerando PDF (pode demorar alguns segundos)...',
  pdfGerado: 'PDF gerado e baixado!',
  areaRelatorioNaoEncontrada: 'Área do relatório não encontrada',
  erroGerarPDF: 'Erro ao gerar PDF. Verifique o console e tente novamente.',
  tentarNovamente: 'Tentar novamente',
  erroCarregar: 'Erro ao carregar',
  exportarRelatorio: 'Exportar Relatório',
  seguranca: 'Segurança',
  proprietario: 'Proprietário',

  // TEMPLATES
  modelosProntos: 'Modelos prontos para demandas, reuniões, relatórios e mais',
  gerarComIA: 'Gerar com IA',
  gerando: 'Gerando...',
  novoTemplate: 'Novo Template',
  buscarTemplate: 'Buscar por nome, descrição ou conteúdo...',
  maisRecentes: 'Mais recentes',
  aZ: 'A → Z',
  favoritosPrimeiro: 'Favoritos primeiro',
  nenhumTemplateEncontrado: 'Nenhum template encontrado',
  semTemplatesAinda: 'Você ainda não tem templates',
  ajusteFiltros: 'Tente ajustar os filtros ou limpar a busca',
  crieTemplatesReutilizaveis: 'Crie templates reutilizáveis para agilizar seu trabalho',
  criarPrimeiroTemplate: 'Criar Primeiro Template',
  criarNovoTemplate: 'Criar novo template',
  templateGeradoIA: 'Template Gerado por IA',
  iaGerado: 'IA Gerado',
  templateCriadoIA: 'Template criado automaticamente com assistência de IA',
  conteudoTemplateIA: '# Título da Demanda\n\n## Objetivo\n\n## Passos / Requisitos\n- Item 1\n- Item 2\n\n## Critérios de Aceitação\n- Critério 1\n- Critério 2\n\n## Notas / Riscos\n\n## Prazo Estimado\n\n## Responsável',
  removidoFavoritos: 'Removido dos favoritos',
  adicionadoFavoritos: 'Adicionado aos favoritos',
  erroFavorito: 'Erro ao atualizar favorito',
  confirmarExcluirTemplate: 'Tem certeza que deseja excluir este template?',
  templateExcluido: 'Template excluído com sucesso.',
  erroExcluirTemplate: 'Erro ao excluir template',
  templateDuplicado: 'Template duplicado!',
  erroDuplicarTemplate: 'Erro ao duplicar template',
  semConteudoTemplate: 'Este template não tem conteúdo para copiar.',
  conteudoCopiado: 'Conteúdo copiado para a área de transferência!',
  editarTemplate: 'Editar Template',
  nomeObrigatorio: 'O nome é obrigatório',
  categoriaObrigatoria: 'A categoria é obrigatória',
  descricaoObrigatoria: 'A descrição é obrigatória',
  conteudoObrigatorio: 'O conteúdo do template é obrigatório',
  preenchaCamposObrigatorios: 'Preencha todos os campos obrigatórios.',
  templateAtualizado: 'Template atualizado!',
  templateCriado: 'Template criado com sucesso!',
  erroSalvarTemplate: 'Erro ao salvar template',
  salvarTemplate: 'Salvar Template',
  nome: 'Nome',
  exReuniaoSprint: 'Ex: Reunião de Planejamento de Sprint',
  categoria: 'Categoria',
  exReunioesBugsFeatures: 'Ex: Reuniões, Bugs, Features...',
  breveDescricaoTemplate: 'Breve descrição do propósito e uso deste template...',
  conteudoTemplate: 'Conteúdo do Template',
  escrevaConteudoTemplate: 'Escreva aqui o conteúdo que será copiado ao usar o template...\n\nSuporta Markdown, listas, tabelas, etc.',

  // CONFIGURAÇÕES (página)
  informacoesPessoais: 'Informações Pessoais',
  fotoPerfil: 'Foto de Perfil',
  alterarFotoPerfil: 'Alterar Foto de Perfil',
  nomeCompleto: 'Nome Completo',
  digiteSeuNomeCompleto: 'Digite seu nome completo',
  seuNome: 'Seu Nome',
  emailNaoPodeSerAlteradoAinda: 'E-mail não pode ser alterado ainda',
  seuEmailPrincipal: 'Seu e-mail principal',
  membroDesde: 'Membro desde',
  aparenciaDaAplicacao: 'Aparência da Aplicação',
  claro: 'Claro',
  escuro: 'Escuro',
  seguirSistema: 'Seguir Sistema',
  cinza: 'Cinza Neutro',
  idiomaDaInterface: 'Idioma da Interface',
  portugueseBrazil: 'Português (Brasil)',
  englishUnitedStates: 'Inglês (Estados Unidos)',
  preferenciasDeNotificacoes: 'Preferências de Notificações',
  novasDemandas: 'Novas Demandas',
  receberQuandoNovaDemandaCriada: 'Receber quando uma nova demanda for criada',
  mensagensChat: 'Mensagens do Chat',
  notificacoesNovasMensagens: 'Notificações de novas mensagens',
  prazosProximos: 'Prazos Próximos',
  lembretesDePrazos: 'Lembretes de prazos',
  atualizacoesSistema: 'Atualizações do Sistema',
  novidadesEHavk: 'Novidades e atualizações do Havk',
  segurancaDaConta: 'Segurança da Conta',
  senhaAtual: 'Senha Atual',
  novaSenha: 'Nova Senha',
  confirmarNovaSenha: 'Confirmar Nova Senha',
  atualizarSenha: 'Atualizar Senha',
  autenticacaoDoisFatores: 'Autenticação de Dois Fatores',
  '2faAumentaSeguranca': '2FA aumenta a segurança da conta',
  ativar2FA: 'Ativar 2FA',
  emBreve: '(em breve)',
  exportarMeusDados: 'Exportar Meus Dados',
  excluirConta: 'Excluir Conta',
  sair: 'Sair',
  confirmarLogout: 'Tem certeza que deseja sair?',
  simSair: 'Sim, sair',
  confirmeExclusaoConta: 'Confirme a exclusão da conta (ação irreversível)',
  contaExcluida: 'Conta excluída (simulado)',
  arquivoMuitoGrande: 'Arquivo excede 5MB',
  fotoAtualizada: 'Foto de perfil atualizada',
  perfilSalvo: 'Perfil salvo com sucesso',
  erroSalvar: 'Erro ao salvar perfil',
  preenchaTodosCamposSenha: 'Preencha todos os campos de senha',
  senhasNaoCoincidem: 'As senhas não coincidem',
  senhaMin8Caracteres: 'A nova senha deve ter no mínimo 8 caracteres',
  senhaAlterada: 'Senha alterada com sucesso',
  dadosExportados: 'Dados exportados com sucesso',

  // NOTAS
  minhasNotas: 'Minhas Notas',
  novaNota: 'Nova Nota',
  editarNota: 'Editar Nota',
  tituloDaNota: 'Título da nota',
  escrevaSuaNotaAqui: 'Escreva sua nota aqui...',
  selecioneOuCrieNota: 'Selecione ou crie uma nota',
  preenchaTituloOuConteudo: 'Preencha o título ou conteúdo',
  notaCriada: 'Nota criada com sucesso',
  notaAtualizada: 'Nota atualizada com sucesso',
  erroSalvarNota: 'Erro ao salvar nota',

  // OBJETIVOS
  objetivosEResultados: 'Objetivos & Resultados',
  novoObjetivo: 'Novo Objetivo',
  criarObjetivo: 'Criar Objetivo',
  editarObjetivo: 'Editar Objetivo',
  detalhesDoObjetivo: 'Detalhes do Objetivo',
  nenhumObjetivoEncontrado: 'Nenhum objetivo encontrado',
  crieSeuPrimeiroObjetivoOuAjusteFiltros: 'Crie seu primeiro objetivo ou ajuste os filtros',
  exAumentarProdutividade: 'Ex: Aumentar produtividade em 20%',

  // GANTT
  'gantt.title': 'Gráfico de Gantt',

  // 404
  paginaNaoEncontrada: 'Página não encontrada',
  paginaNaoEncontradaDesc: 'A página que você está procurando não existe ou foi movida.',
  voltarDashboard: 'Voltar ao Dashboard',

  footer: {
    copyright: '© {{year}} Havk. Todos os direitos reservados.',
    terms: 'Termos',
    privacy: 'Privacidade',
    help: 'Ajuda',
  },
};
